import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  ActivityIndicator,
  FlatList,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import mystyles from '../../assets/styles/mystyles';
import {callApi, getUserId} from '../Helper/Helper'; // Adjust path as needed
import { useNavigation } from '@react-navigation/native';

const ConsumerFollowing = () => {
  const navigation = useNavigation();
  const [cUserId, setCUserId] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Try to resolve userId if not provided via params
  useEffect(() => {
    (async () => {
      if (!cUserId) {
        try {
          const uid = await getUserId();
          setCUserId(uid || '');
        } catch {
          // ignore, handled on demand
        }
      }
    })();
  }, [cUserId]);



  useEffect(() => {
    const fetchData = async () => {
      if (!cUserId) return; // STOP: Don't fetch if we don't have a user ID yet

      try {

        const json = await callApi('GET', '/eabu-i-follow/'+ cUserId);
        setData(json);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [cUserId]);


  if (loading) {
    return (
      <View style={[mystyles.container, mystyles.center]}>
        <ActivityIndicator size="large" color="#0000ff" />
      </View>
    );
  }

  if (error) {
    return (
      <View style={[mystyles.container, mystyles.center]}>
        <Text style={mystyles.errorText}>Error: {error?.message || JSON.stringify(error)}</Text>
      </View>
    );
  }
  const dataObject = JSON.parse(JSON.stringify(data));
  const items = dataObject?.Items ?? [];
  const count = dataObject?.Count ?? items.length ?? 0;

  return (
    <SafeAreaView style={styles.container}>
      <View style={mystyles.card}>
        <Text style={mystyles.heading}>Following</Text>
        <FlatList
          data={items}
          keyExtractor={(item, index) => item.pUserId ? item.pUserId.toString() : index.toString()}
          renderItem={({ item }) => (
            <TouchableOpacity
              style={styles.itemContainer}
              onPress={() => navigation.navigate('ProviderDetails', { pUserId: item.pUserId })}
            >
              <View style={styles.avatarContainer}>
                <Text style={styles.avatarText}>
                  {(item.pUserId || '?').substring(0, 1).toUpperCase()}
                </Text>
              </View>
              <View style={styles.textContainer}>
                <Text style={styles.nameText}>{item.pUserId}</Text>
                <Text style={styles.subText}>Tap to view profile</Text>
              </View>
              <Text style={styles.arrowIcon}>›</Text>
            </TouchableOpacity>
          )}
          ListEmptyComponent={<Text style={mystyles.emptyText}>You are not following anyone yet.</Text>}
          contentContainerStyle={mystyles.listContent}
        />
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 16,
    borderRadius: 16,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
    borderWidth: 1,
    borderColor: '#f0f0f0',
  },
  avatarContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#F0F8FF',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
    borderWidth: 1,
    borderColor: '#E1E8ED',
  },
  avatarText: {
    fontSize: 20,
    fontWeight: '700',
    color: '#007AFF',
  },
  textContainer: {
    flex: 1,
  },
  nameText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1A1A1A',
    marginBottom: 2,
  },
  subText: {
    fontSize: 12,
    color: '#8E8E93',
  },
  arrowIcon: {
    fontSize: 24,
    color: '#C7C7CC',
    fontWeight: '300',
  },
});
export default ConsumerFollowing;
